/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChatsBulkOperationsDeleteAllFromSectionDesktopRequest,
  TChatsBulkOperationsDeleteAllFromSectionDesktopModel,
  IMappers,
  TChatsBulkOperationsDeleteAllFromSectionDesktopResponse,
  TChatsBulkOperationsDeleteAllFromSectionDesktopResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createChatsBulkOperationsDeleteAllFromSectionDesktopModel(
  parameters: TChatsBulkOperationsDeleteAllFromSectionDesktopRequest,
): TChatsBulkOperationsDeleteAllFromSectionDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/chats/bulk-operations/delete-all-from-section-desktop/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChatsBulkOperationsDeleteAllFromSectionDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChatsBulkOperationsDeleteAllFromSectionDesktopRequest;
}

export async function fetchChatsBulkOperationsDeleteAllFromSectionDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsBulkOperationsDeleteAllFromSectionDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsBulkOperationsDeleteAllFromSectionDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsBulkOperationsDeleteAllFromSectionDesktopModel(parameters),
    config,
  )) as FetchResponse<TChatsBulkOperationsDeleteAllFromSectionDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TChatsBulkOperationsDeleteAllFromSectionDesktopResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsBulkOperationsDeleteAllFromSectionDesktopResponse>;
}
